// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import Material from '../renderer/Material';
import FullscreenUtils from '../renderer/pass/FullscreenUtils';
import ShaderLib from '../renderer/shaders/ShaderLib';
import Pass from '../renderer/pass/Pass';

class HdrPass extends Pass {
    constructor(inputRenderTarget, settings) {
        super();
        settings = settings || {};

        this.inputRenderTarget = inputRenderTarget;

        const width = inputRenderTarget.width;
        const height = inputRenderTarget.height;
        this.updateSize({
            x: 0,
            y: 0,
            width: width,
            height: height
        });

        this.renderable = {
            meshData: FullscreenUtils.quad,
            materials: []
        };
        if (settings.shader) {
            this.copyMaterial = new Material(settings.shader);
        }
        else {
            this.copyMaterial = new Material(ShaderLib.copy);
        }
        this.copyMaterial.setTexture('DIFFUSE_MAP',inputRenderTarget);

        this.enabled = true;
        this.clear = false;
        this.needsSwap = false;
    }

    destroy(renderer) {
        if (this.inputRenderTarget) {
            this.inputRenderTarget.destroy(renderer.context);
        }
        this.copyMaterial.shader.destroy();
    }

    invalidateHandles(renderer) {
        renderer.invalidateMaterial(this.copyMaterial);
        renderer.invalidateRenderTarget(this.inputRenderTarget);
        renderer.invalidateMeshData(this.renderable.meshData);
    }

    render(renderer, writeBuffer, readBuffer) {
        this.renderable.materials[0] = this.copyMaterial;
        this.copyMaterial.setTexture('DIFFUSE_MAP', this.inputRenderTarget);

        renderer.render(this.renderable, null, FullscreenUtils.camera, [], null, this.clear);
    }
}

export default HdrPass;